import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  settheTicketsystemrecordgetListDataActions,
  settheTicketViewIds,
  settheTicketraiseroutes,
  settheTicketsystemrecordgetListInternalDataActions,
  SettheTicketDashboardStatusManagement
} from "../../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { parseISO, addDays, differenceInDays } from "date-fns";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import Swal from "sweetalert2";
import _ from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Inprogressticket from "../../../../Assets/AppComponent/Union (28).svg";
import reviewticker from "../../../../Assets/AppComponent/Union (31).svg";

import reopenticketslist from "../../../../Assets/AppComponent/Union (33).svg";
import resolvedticket from "../../../../Assets/AppComponent/Union (34).svg";
import Cardimgs from "../../../../Assets/AppComponent/Union (27).svg";
import TicketsTable from "./TicketignTable";


const InternalDashboards = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state)
  const DashboardDatas = useSelector((state) => state.TicketingInertnalDashboardCalls.TicketingInternalDashboarddata)
  const navigate = useNavigate()
  const [activeButton, setActiveButton] = useState("Open");

  const handleButtonClick = (button) => {
    setActiveButton(button);
    // SetActiveBars(button);
  };
  useEffect(() => {
    dispatch(SettheTicketDashboardStatusManagement("Open"))
  }, [])
  const HandletheActived = (tab) => {
    setActiveButton(tab);
    dispatch(SettheTicketDashboardStatusManagement(tab))
  }
  useEffect(() => {
    dispatch(settheTicketraiseroutes(0))
  }, [])
  useEffect(() => {
    const payload = {
      ticket_assign: false
    }
    dispatch(settheTicketsystemrecordgetListInternalDataActions(payload))
  }, [])


  console.log(activeButton, "activeButton", state.NeededdatasListed.TicketDashboardMangements);
  console.log("UDS_ticket_user_typelist sdiuo UDS_ticket_user_typelist",
    state.NeededdatasListed.TicketDashboardMangements,
    DashboardDatas
  );

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details  HeaderofTicketings row"
          style={{
            padding: "4px 20px",
            // margin:"16px 15px !important",
            width: "98%",

          }}
        >
          <div
            class="col-12 "
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              height: "60px",
              background: "#fff",
              marginBottom: "24px",
              borderRadius: "12px",
              // boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
            }}
          >
            <h3
              className="TicketDasboardHeader" style={{ marginTop: "10px" }}>Created Tickets</h3>
            <div className="createticketing col-sm-5">
              <button
                style={{ zIndex: "555" }}
                onClick={(e) => {
                  dispatch(settheTicketViewIds(""))
                  navigate("/internalTicketCreate")
                }}
                className="Createbutton"
              >
                Raise a Ticket
              </button>
            </div>
          </div>

        </div>
        <div className="row mt-3 ticket-dashboard">
          <div className="row Ticketdetails">
            <div className=" Innerticket-dashboard text-center">


              <div
                className={`col-md-4 CardDesigns mb-3 ${activeButton === "Open" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Open")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData InnercardImgDataTicketcreate">
                    <span className="FrstCard">
                      <img src={Cardimgs} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.open_ticketing_count}</h2>
                  </div>
                  <h5>Open Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 CardDesigns mb-3 ${activeButton === "In Progress" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("In Progress")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="secondCard">
                      <img src={Inprogressticket} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.inprocess_ticketing_count}</h2>
                  </div>
                  <h5>In Progress Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 mb-3 ${activeButton === "Review" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Review")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="threeCard">
                      <img src={reviewticker} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.review_tickets_count}</h2>
                  </div>
                  <h5>Review Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 mb-3 ${activeButton === "Reopen" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Reopen")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="fourCard">
                      <img src={reopenticketslist} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.reopen_ticketing_count}</h2>
                  </div>
                  <h5>Reopened Tickets</h5>
                </div>
              </div>

              <div
                className={`col-md-4 mb-3 ${activeButton === "Resolved" ? "active-card" : ""
                  }`}
                onClick={() => handleButtonClick("Resolved")}
              >
                <div className="card p-3">
                  <div className="InnercardImgData">
                    <span className="fiveCard">
                      <img src={resolvedticket} alt="Card Icon" />
                    </span>
                    <h2>{DashboardDatas.resolved_tickets}</h2>
                  </div>
                  <h5>Resolved Tickets</h5>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="row TicketTable_">
          <TicketsTable setActiveButton={setActiveButton} activeButton={activeButton} HandletheActived={HandletheActived} />

        </div>
      </div>

    </>
  )
}

export default InternalDashboards